module.exports = __webpack_public_path__ + "static/media/master-card.65d21526.png";